import { Component, ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBar as MatSnackBar, MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error) {
    console.log(error);
    let message = 'Uh oh, something went wrong, but were not 100% sure what it was. Please try again!';

    if (error) {
      /**
       * no need to throw dialogs for ngDebug Errors
       */
      if (error.hasOwnProperty('ngDebugContext')) {
        return true;
      }
      if (error.hasOwnProperty('rejection')) {
        message = error.rejection.message;
      } else if (error.hasOwnProperty('message')) {
        message = error.message;
      }
      if (message === 'undefined: undefined') {
        return true;
      }
    }
    if (error.hasOwnProperty('url')) {
      if (error.url.includes('/login') && error.status === 403) {
        message = 'Invalid email or password';
      }
      if (error.url.includes('/request-phone-verify')) {
        message = 'We were unable to send a message to the phone number you entered.';
      }
      if (error.url.includes('/forgot-password')) {
        message = 'We were unable to find a user matching the email you entered.';
      }
      if (error.url.includes('/integrations')) {
        message = 'There was a problem with your credentials. Please verify them and try again.';
      }
    }

    if (error && error.error && !error.error.disableDefaultHandling) {
      const errorSnackBarRef = this.injector.get(MatSnackBar).openFromComponent(ErrorSnackBarComponent, {
        data: message,
        verticalPosition: 'top',
        duration: 5000,
        panelClass: 'error-snack-bar'
      });
      errorSnackBarRef.instance.snackBarRef = errorSnackBarRef;
    }
  }
}

@Component({
  selector: 'app-error-snack-bar',
  templateUrl: 'error-snack-bar.component.html',
  styleUrls: ['./error-snack-bar.component.scss']
})
export class ErrorSnackBarComponent {
  public snackBarRef: MatSnackBarRef<ErrorSnackBarComponent>;
  // public snackBarRef: any;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  closeError() {
    console.log('close this');
    console.log(this);
  }
}
